module.exports = __webpack_public_path__ + "static/media/6movies-item.2a5a47b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/6movies-item.png
// module id = 218
// module chunks = 0